import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/profile/add-imaging-center")({
    component: () => <div>Hello /_app/profile/add-imaging-center!</div>,
});
